import React, { useEffect } from 'react';
import AdvanceTable from 'components/common/advance-table/AdvanceTable';
import AdvanceTableFooter from 'components/common/advance-table/AdvanceTableFooter';
import AdvanceTableProvider from 'providers/AdvanceTableProvider';
import useAdvanceTable from 'hooks/useAdvanceTable';
import DatePicker from 'react-datepicker';
import classNames from 'classnames';
import SubtleBadge from 'components/common/SubtleBadge';
import { Spinner } from 'react-bootstrap';

const columns = [
  {
    accessorKey: 'nfact',
    header: 'Numéro vente',
    meta: {
      headerProps: { className: 'white-space-nowrap text-900' },
      cellProps: { className: 'font-sans-serif white-space-nowrap fs-10' },
    },
  },
  {
    accessorKey: 'codeproduit',
    header: 'Client',
    meta: {
      headerProps: { className: 'text-start text-900 ' },
      cellProps: {
        className: 'ps-2 text-start w-5 fw-semibold fs-10 white-space-nowrap',
      },
    },
  },
  {
    accessorKey: 'produit',
    header: 'Produit',
    meta: {
      headerProps: { className: 'text-start text-900 ' },
      cellProps: {
        className: 'ps-2 text-start w-5 fw-semibold fs-10 white-space-nowrap',
      },
    },
  },
  {
    accessorKey: 'mntdt',
    header: 'prix untaire',
    meta: {
      headerProps: { className: 'text-end text-900 ' },
      cellProps: {
        className: 'ps-2 text-end w-5 fw-semibold fs-10',
      },
    },
  },
  {
    accessorKey: 'qte',
    header: 'Quantité',
    meta: {
      headerProps: { className: 'text-end text-900 ' },
      cellProps: {
        className: 'ps-2 text-end w-5 fw-semibold fs-10',
      },
    },
  },
  {
    accessorKey: 'promo',
    header: 'Promo',
    meta: {
      headerProps: { className: 'text-end text-900 ' },
      cellProps: {
        className: 'ps-2 text-end w-5 fw-semibold fs-10',
      },
    },
  },
  {
    accessorKey: 'prixFinal',
    header: 'Prix final',
    cell: ({ row }) => {
      const { mntdt, qte, promo } = row.original;
      return <span>{(mntdt * qte * (1 - promo / 100)).toFixed(3)}</span>;
    },
    meta: {
      headerProps: { className: 'text-end text-900 ' },
      cellProps: {
        className: 'ps-2 text-end w-5 fw-semibold fs-10',
      },
    },
  },
];

const FacturesVentes = ({ ventes, loading }) => {
  const table = useAdvanceTable({
    data: ventes,
    columns: columns,
    selection: true,
    sortable: true,
    pagination: true,
    perPage: 100,
    selectionColumnWidth: 52,
  });

  return loading ? (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 200 }}>
      <Spinner animation="border" variant="primary" />
    </div>
  ) : (
    <AdvanceTableProvider {...table}>
      <AdvanceTable />
      <AdvanceTableFooter rowInfo navButtons />
    </AdvanceTableProvider>
  );
};

export default FacturesVentes;
